import React from "react";

const FileIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="#354052"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m15 7.326-6.5 6.5a2.121 2.121 0 0 0 3 3l6.5-6.5a4.242 4.242 0 1 0-6-6l-6.5 6.5a6.364 6.364 0 0 0 9 9l6.5-6.5"
    ></path>
  </svg>
);

export default FileIcon;
